import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_OWN_WORKSPACE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createOwnWorkspaceBidder($input: CreateOwnWorkspaceBidderInput!) {
    result: createOwnWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
